import type { FaireProductEntity } from "../../entity_types/product";

export const p_daghvh57d5: FaireProductEntity = {
  token: "p_daghvh57d5",
  type: "product",
  name: "Spray Body Oil – Sweet Almond, Jojoba & Coconut Oil",
  brandToken: "b_i2w3l6b8",
  brandName: "Rock Bottom Soap",
  imageUrl:
    "https://cdn.faire.com/fastly/9a91f1c5683f5b754e76d3f9ec2735b68c2d8927119f90fe325577360879f08f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/379e26dd1b0279a585092f7a19736cbd7567c1f02e01d5c7fd436c095a0c3958.jpeg",
  ],
  priceDollars: 9.01,
  description:
    "Our lightweight, deeply nourishing Body Oil blends sweet almond, jojoba, and fractionated coconut oils to leave your skin silky smooth and glowing—not greasy. Perfect for post-shower hydration, massage, or anytime your skin needs a little love.\n\nFun, fast-absorbing, and packed with all-natural goodness, this oil is your daily glow-up in a bottle.\n\n- Lightweight Blend – No heavy residue, just happy skin &nbsp;\n- All-Natural Formula – Only three nourishing plant oils &nbsp;\n- Clean Beauty – Free from synthetics, parabens, or fillers &nbsp;\n- Multi-Use – Great for body hydration, massage, or bath &nbsp;\n- Travel-Friendly Size – 4oz bottle, perfect on the go &nbsp;",
  tags: [],
  msrpDollars: 18.01,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:42.412Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
